/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export default () => ({
  link: () => `/v2/blobstore/resumes/${chance.guid()}`,
});
